module.exports = __webpack_public_path__ + "static/elephant-fc6798a6b6798d44f4cc927dc3723db8.jpg";